import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const BASE_URL = `${environment.apiOrg.url}/users`;

@Injectable({ providedIn: 'root' })
export class ResendVerifyEmailService {
  constructor(private http: HttpClient) {}

  public resendVerifyEmail(userId: string): Observable<void> {
    const url = `${BASE_URL}/${userId}/resend-verify-email`;
    return this.http.post<void>(url, null);
  }
}
